import { useQuery, useQueryClient } from "@tanstack/react-query"
import { isFirstFactura } from "./Factura.service"

export function useIsFirstFactura(id?: string) {
  const queryClient = useQueryClient()

  const {
    data: isFirstFacturaData,
    isLoading: isFirstFacturaIsLoading,
    error: isFirstFacturaError,
    refetch: isFirstFacturaRefetch,
  } = useQuery<boolean>({
    queryKey: ["isFirstFactura", id],
    queryFn: () => isFirstFactura(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
    retry: false,
  })

  const invalidateIsFirstFactura = () =>
    queryClient.invalidateQueries({ queryKey: ["isFirstFactura"] })

  return {
    isFirstFactura: isFirstFacturaData,
    isFirstFacturaIsLoading,
    isFirstFacturaError,
    invalidateIsFirstFactura,
    isFirstFacturaRefetch,
  }
}
